const calendlyStyle = {
  backButton: {
    marginTop: "2rem",
  },
  contentContainer: {
    padding: "25px",
    maxWidth: "500px",
    margin: "0 auto",
  },
};

export default calendlyStyle;
